import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";

import { useAuth } from "merchant-portal-frontend/src/providers/AuthProvider";
import { routes } from "merchant-portal-pages/routes";

export const AuthenticatedRoutes = () => {
	const { pathname } = useLocation();
	const { isAuthenticated, oktaAuth } = useAuth();

	if (!isAuthenticated && !oktaAuth?.token?.isLoginRedirect()) {
		return <Navigate to={{ pathname: routes.login }} state={{ from: pathname }} />;
	}

	return <Outlet />;
};
